import { render, staticRenderFns } from "./FunctionalityCard.vue?vue&type=template&id=8a3a6ecc&scoped=true&"
import script from "./FunctionalityCard.vue?vue&type=script&lang=js&"
export * from "./FunctionalityCard.vue?vue&type=script&lang=js&"
import style0 from "./FunctionalityCard.vue?vue&type=style&index=0&id=8a3a6ecc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a3a6ecc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCardSubtitle } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VCardSubtitle,VCardTitle,VChip,VIcon})
